import React from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import hImg from "../../images/shape/hero-glassisom2.png";

const Hero3 = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className="hero hero-style-six pos-rel pt-110">
      <div className="container">
        <div className="hero_wrap">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="xb-hero">
                <Fade
                  direction="up"
                  triggerOnce={"false"}
                  duration={800}
                  delay={6}
                >
                  <div>
                    <h1
                      className="xb-item--title wow fadeInUp"
                      data-wow-delay="0ms"
                      data-wow-duration="600ms"
                    >
                      Transform Your Business with ServiceNow Excellence
                    </h1>
                  </div>
                </Fade>
                <Fade
                  direction="up"
                  triggerOnce={"false"}
                  duration={1500}
                  delay={9}
                >
                  <div>
                    <p
                      className="xb-item--content wow fadeInUp"
                      data-wow-delay="150ms"
                      data-wow-duration="600ms"
                    >
                      Unlock the full potential of your IT infrastructure with
                      expert ServiceNow solutions, streamlining operations and
                      automating workflows. We enhance efficiency and drive
                      digital transformation for seamless business growth.
                    </p>
                  </div>
                </Fade>
                <Fade
                  direction="up"
                  triggerOnce={"false"}
                  duration={1800}
                  delay={9}
                >
                  <div>
                    <div
                      className="d-flex flex-wrap gap-4 mt-50 wow fadeInUp"
                      data-wow-delay="300ms"
                      data-wow-duration="600ms"
                    >
                      {/* Button 1: Get a Free Consultation */}
                      <Link
                        onClick={ClickHandler}
                        to="/contact"
                        className="thm-btn thm-btn--fill_icon thm-btn--data"
                      >
                        <div className="xb-item--hidden">
                          <span className="xb-item--hidden-text">
                            Get a Free Consultation
                          </span>
                        </div>
                        <div className="xb-item--holder">
                          <span className="xb-item--text xb-item--text1">
                            Get a Free Consultation
                          </span>
                          <div className="xb-item--icon xb-item--icon-rotate">
                            <i className="fal fa-arrow-right"></i>
                          </div>
                          <span className="xb-item--text xb-item--text2">
                            Get a Free Consultation
                          </span>
                        </div>
                      </Link>

                      {/* Button 2: Join Our Team */}

                      <Link
                        onClick={ClickHandler}
                        to="/career"
                        className="thm-btn thm-btn--fill_icon thm-btn--data btn-orange"
                      >
                        <div className="xb-item--hidden">
                          <span className="xb-item--hidden-text">
                            Join Our Team
                          </span>
                        </div>
                        <div className="xb-item--holder">
                          <span className="xb-item--text xb-item--text1">
                            Join Our Team
                          </span>
                          <div className="xb-item--icon xb-item--icon-v1" style={{background: "#fff", color:"#FF842D"}}>
                            <span>
                              <i className="fal fa-plus"></i>
                            </span>
                          </div>
                          <span className="xb-item--text xb-item--text2">
                            Join Our Team
                          </span>
                        </div>
                      </Link>

                      {/* <Link
  onClick={ClickHandler}
  to="/careers"
  className="thm-btn thm-btn--fill_icon thm-btn--data thm-btn--data btn-orange"
>

  <div  className="xb-item--hidden">
    <span className="xb-item--hidden-text ">Join Our Team</span>
  </div>
  <div className="xb-item--holder">
    <span className="xb-item--text xb-item--text1">Join Our Team</span>

    <div className="xb-item--icon">
      <span><i className="fal fa-plus"></i></span>
    </div>
    <span className="xb-item--text xb-item--text2">Join Our Team</span>
  </div>
</Link> */}
                    </div>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </div>
        <div className="xb-shape">
          <img src={hImg} alt="" />
        </div>
      </div>
    </section>
  );
};

export default Hero3;
